import './style.scss';
// import inGameLogo from '../../../assets/svg/logo.svg';
import searchLogo from '../../../assets/svg/search-doc-icon.svg';
import { SpriteSvg, SpriteSvgType } from '../../../components/sprite-svg';
// import { getPlatform } from '../../../lib/platform';
import {
  LanguageType,
  // PlatformType,
  IAppDocPidConfigItem,
} from '../../../model';
// import { getLogout } from '../../../api';
// import { useSelector } from 'react-redux';
// import { IRootState } from '../../../store/reducers';
// import { jumpToLogin } from '../../lib';
// import { AccountCenter } from '../../user/account-center';
// import { MessageComp } from './message';
import { SearchContent } from './search-content';
import React, { useEffect, useRef, useState } from 'react';
import { getConfig } from '../../../config';
import { message } from 'antd';
import { getDocumentParams, getDocumentUrl } from '../../document/utils';
// import { ItemUserComponent } from '../header/item-user';
import getFormatMessage from '../../../locales/get-format-message';
// import { DropDownBox } from '../../../components/dropdown-box';
import { GlobalNotification } from '../global-notification';
import classNames from 'classnames';
import { LanguageType as Lang } from '../../../lib';
import { isMobile } from '../../../lib/mobile';

interface IOption {
  readonly label: string;
  readonly value: number;
}

interface IProps {
  readonly isDocPublicRoute: boolean;
  readonly showUpgradeNotice: boolean;
}

export const HeaderComp = (props: IProps) => {
  const { showUpgradeNotice = true } = props;
  const query = getDocumentParams();
  const [showNotice, setShowNotice] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const childRef = useRef<any>();
  let langConfig: IAppDocPidConfigItem | null = null;
  const switchOption: IOption[] = [];
  (getConfig()?.documentConfig?.modules || []).forEach((item) => {
    if (
      item.pid.en_US === +query?.projectId ||
      item.pid.zh_CN === +query?.projectId
    ) {
      langConfig = item.pid;
    }
  });

  if (langConfig) {
    (getConfig()?.documentConfig?.modules || []).forEach((item) => {
      switchOption.push({
        label: item.name,
        value:
          langConfig?.zh_CN === +query?.projectId
            ? item.pid.zh_CN
            : item.pid.en_US,
      });
    });
  }
  // const [selectedValue, setSelectedValue] = useState<number>();
  // const langConfig = (getConfig()?.documentConfig?.modules || []).find((v) =>
  //   Object.values(v).includes(+query?.projectId)
  // );
  // const platform = getPlatform();
  // const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  // const [visible, setVisible] = useState<boolean>(false);
  const [lang, setLang] = useState<LanguageType | null>(null);

  useEffect(() => {
    const handlePageClick = (e: any) => {
      const targetElement = e.target;
      const isDivOrAnchor =
        targetElement.classList.contains('document-search-drawer') ||
        targetElement.closest('.document-search-drawer');
      if (!isDivOrAnchor && !isMobile()) {
        setIsOpenDrawer(false);
        setSearchValue('');
        if (childRef.current) {
          childRef.current.onClose();
        }
      }
    };

    // 监听整个文档的点击事件
    document.addEventListener('click', handlePageClick);

    return () => {
      document.removeEventListener('click', handlePageClick);
    };
  }, []);

  const onToggleLang = () => {
    if (query.projectId) {
      if (langConfig) {
        const { en_US: en, zh_CN: zh } = langConfig;
        if (en && zh) {
          const id = lang === LanguageType.EN ? zh : en;
          if (id) {
            const url = getDocumentUrl(props.isDocPublicRoute, id);
            location.href = url;
            return;
          }
        }
      }
      message.error('无对应的文档');
    }
  };

  const getCurrentLang = () => {
    const projectId = query?.projectId;
    if (!projectId) return;
    if (langConfig) {
      const isZh = +projectId === langConfig.zh_CN;
      setLang(isZh ? LanguageType.ZH : LanguageType.EN);
    }
  };

  const onKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      if (!searchValue) return;
      setIsOpenDrawer(true);
    }
  };

  // const bindKeyboardEvent = () => {
  //   const fn = (e: any) => {
  //     const { keyCode, ctrlKey, metaKey } = e;
  //     if (platform === PlatformType.Mac) {
  //       if (keyCode === 75 && metaKey) {
  //         setVisible(true);
  //       }
  //     } else {
  //       if (keyCode === 75 && ctrlKey) {
  //         setVisible(true);
  //       }
  //     }
  //   };
  //   window.addEventListener('keydown', fn, false);
  //   return () => {
  //     window.removeEventListener('keydown', fn, false);
  //   };
  // };

  useEffect(() => {
    getCurrentLang();
    // return bindKeyboardEvent();
  }, []);

  const onSearchChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  const renderSearch = () => {
    return (
      <>
        {isMobile() ? (
          <div>
            <img
              src={searchLogo}
              style={{ width: 32, height: 32 }}
              onClick={() => setIsOpenDrawer(true)}
            />
          </div>
        ) : (
          <div className="gc-header-search">
            <div className="search-left">
              <img src={searchLogo} />
              {/* <SpriteSvg width={16} height={16} type={SpriteSvgType.SearchDark} /> */}
              <input
                type="text"
                placeholder={getFormatMessage(
                  'search_ingame_docs',
                  {},
                  lang === LanguageType.ZH ? Lang.zh_CN : Lang.en_US
                )}
                onChange={onSearchChange}
                className="search-bar"
                value={searchValue}
                onKeyDown={onKeyDown}
              />
            </div>
          </div>
        )}
      </>
    );
  };

  // const renderKeyboard = () => {
  //   return platform === PlatformType.Mac ? (
  //     <>
  //       <SpriteSvg width={17} height={20} type={SpriteSvgType.Command} />
  //       <SpriteSvg
  //         width={17}
  //         height={20}
  //         type={SpriteSvgType.KeyboardK}
  //         marginLeft={6}
  //       />
  //     </>
  //   ) : (
  //     <>
  //       <SpriteSvg width={24} height={20} type={SpriteSvgType.KeyboardCtrl} />
  //       <SpriteSvg
  //         width={17}
  //         height={20}
  //         type={SpriteSvgType.KeyboardK}
  //         marginLeft={6}
  //       />
  //     </>
  //   );
  // };

  const renderLanguage = () => {
    const hasConfig = langConfig?.en_US && langConfig?.zh_CN;
    if (!lang || !hasConfig) return null;
    return (
      <a className="action-item" onClick={onToggleLang}>
        <span className="action-icon">
          <SpriteSvg
            width={isMobile() ? 28 : 15}
            height={isMobile() ? 28 : 15}
            type={
              lang === LanguageType.ZH
                ? SpriteSvgType.LanguageZH
                : SpriteSvgType.LanguageEN
            }
          />
        </span>
      </a>
    );
  };

  return (
    <div
      className={classNames('header-comp-container', {
        ['gc-header-has-notice']: showNotice,
      })}
    >
      {showUpgradeNotice && (
        <GlobalNotification onDisplayChange={(show) => setShowNotice(show)} />
      )}

      <div className="gc-header-comp">
        <div className="header-title">
          {getFormatMessage(
            'document_center',
            {},
            lang === LanguageType.ZH ? Lang.zh_CN : Lang.en_US
          )}
        </div>
        <div className="gc-operation">
          {renderSearch()}
          {renderLanguage()}
        </div>
      </div>
      <div className="gc-header-place"></div>
      <SearchContent
        onClose={() => {
          setSearchValue('');
          setIsOpenDrawer(false);
        }}
        searchValue={searchValue}
        isOpenDrawer={isOpenDrawer}
        isDocPublicRoute={props.isDocPublicRoute}
        lang={lang}
        ref={childRef}
      />
    </div>
  );
};
